  // Unified initializer
  function initMobileMenu() {
    bindHamburgerToggle();
    bindSubmenuToggles();
    bindMegaMenuToggles();
    overflowMenuToMore();
    bindMoreMenuToggle();
  }

  // 1) Hamburger toggle
  function bindHamburgerToggle() {
    const toggleBtn = document.querySelector('.mobile-menu-toggle');
    const mainNav   = document.querySelector('.main-navigation');
    if (!toggleBtn || !mainNav) return;
    toggleBtn.addEventListener('click', function() {
      toggleBtn.classList.toggle('active');
      mainNav  .classList.toggle('active');
      const isOpen = mainNav.classList.contains('active');
      toggleBtn.setAttribute('aria-expanded', isOpen);
      document.body.style.overflow = isOpen ? 'hidden' : '';
    });
  }

  // 2) Simple mobile sub-menu toggles
  function bindSubmenuToggles() {
    document.querySelectorAll('.has-submenu > a').forEach(link => {
      link.addEventListener('click', function(e) {
        if (window.innerWidth <= 768) {
          e.preventDefault();
          link.parentElement.classList.toggle('open');
        }
      });
    });
  }

  // 3) Mobile mega-menu toggles
  function bindMegaMenuToggles() {
    const items = document.querySelectorAll('.nav-item.has-mega-menu');
    items.forEach(item => {
      const link = item.querySelector('.nav-link');
      if (!link) return;
      link.addEventListener('click', function(e) {
        if (window.innerWidth <= 768) {
          e.preventDefault();
          items.forEach(other => other !== item && other.classList.remove('active'));
          item.classList.toggle('active');
        }
      });
    });
  }

 function overflowMenuToMore() {
    const navList      = document.querySelector('.nav-list');
    const moreMenu     = navList?.querySelector('.more-menu');
    const moreDropdown = moreMenu?.querySelector('.more-menu-dropdown');
    if (!navList || !moreMenu || !moreDropdown) return;

    // 1) only immediate children, not nested clones
    const items = Array.from(navList.querySelectorAll(':scope > .nav-item:not(.more-menu)'));

    // 2) clear any previous clones
    moreDropdown.innerHTML = '';
    items.forEach(i => i.style.display = '');
    moreMenu.style.display = 'none';

    if (window.innerWidth < 768) return;

    const available = navList.offsetWidth - moreMenu.offsetWidth - 20; // buffer
    let used = 0, overflow = [];

    items.forEach(i => {
      used += i.offsetWidth;
      if (used > available) overflow.push(i);
    });

    if (overflow.length) {
      moreMenu.style.display = '';
      overflow.forEach(i => {
        // clone *just* the item itself
        moreDropdown.appendChild(i.cloneNode(true));
        i.style.display = 'none';
      });
    }
  }

  // 5) “More” toggle behavior
  function bindMoreMenuToggle() {
    const moreMenu = document.querySelector('.more-menu');
    if (!moreMenu) return;
    const toggle = moreMenu.querySelector('.more-menu-toggle');
    toggle.addEventListener('click', e => {
      e.preventDefault();
      moreMenu.classList.toggle('show');
    });
    document.addEventListener('click', e => {
      if (!moreMenu.contains(e.target)) moreMenu.classList.remove('show');
    });
  }

  // Debounce helper so resize doesn’t reflow on every pixel
  function debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn(...args), wait);
    };
  }
  // --- Hooks ---
  document.addEventListener('DOMContentLoaded', initMobileMenu);
  document.addEventListener('shopify:section:load', initMobileMenu);
  window.addEventListener('resize', overflowMenuToMore);


let currentLevel = 0;
let navigationHistory = [];

function toggleMobileMenu() {
  const overlay = document.querySelector('.mobile-menu-overlay');
  const drawer = document.querySelector('.mobile-drawer');
  
  overlay.classList.toggle('active');
  drawer.classList.toggle('active');
  
  // Prevent body scroll when menu is open
  if (drawer.classList.contains('active')) {
    document.body.style.overflow = 'hidden';
    resetToMainMenu();
  } else {
    document.body.style.overflow = '';
  }
}

function closeMobileMenu() {
  const overlay = document.querySelector('.mobile-menu-overlay');
  const drawer = document.querySelector('.mobile-drawer');
  
  overlay.classList.remove('active');
  drawer.classList.remove('active');
  document.body.style.overflow = '';
  
  setTimeout(() => {
    resetToMainMenu();
  }, 300);
}

function navigateToSubmenu(event, menuId) {
  event.preventDefault();
  
  const targetLevel = document.querySelector(`[data-parent="${menuId}"]`);
  if (!targetLevel) return;
  
  navigationHistory.push({
    level: currentLevel,
    title: document.querySelector('.drawer-title').textContent
  });
  
  const targetLevelNumber = parseInt(targetLevel.getAttribute('data-level'));
  
  const currentLevelElement = document.querySelector('.menu-level.active');
  if (currentLevelElement) {
    currentLevelElement.classList.remove('active');
    currentLevelElement.classList.add('prev');
  }
  
  targetLevel.classList.add('active');
  targetLevel.classList.remove('prev');
  
  currentLevel = targetLevelNumber;
  updateHeader();
}

function navigateBack() {
  if (navigationHistory.length === 0) return;
  
  const prevState = navigationHistory.pop();
  
  const currentLevelElement = document.querySelector('.menu-level.active');
  if (currentLevelElement) {
    currentLevelElement.classList.remove('active');
  }
  
  const prevLevelElement = document.querySelector(`[data-level="${prevState.level}"]`);
  if (prevLevelElement) {
    prevLevelElement.classList.add('active');
    prevLevelElement.classList.remove('prev');
  }
  
  currentLevel = prevState.level;
  updateHeader();
}

function updateHeader() {
  const backButton = document.querySelector('.drawer-back');
  const title = document.querySelector('.drawer-title');
  
  if (currentLevel === 0) {
    backButton.style.display = 'none';
    title.textContent = 'Menu';
  } else {
    backButton.style.display = 'flex';
    
    const currentLevelElement = document.querySelector('.menu-level.active');
    const parent = currentLevelElement.getAttribute('data-parent');
    
    // Set title based on parent
    if (parent === 'browse') {
      title.textContent = 'Browse';
    } else if (parent.startsWith('browse-')) {
      const parentLink = parent.replace('browse-', '');
      title.textContent = parentLink.charAt(0).toUpperCase() + parentLink.slice(1);
    } else {
      title.textContent = parent.charAt(0).toUpperCase() + parent.slice(1);
    }
  }
}

function resetToMainMenu() {
  document.querySelectorAll('.menu-level').forEach(level => {
    level.classList.remove('active', 'prev');
  });
  
  document.querySelector('[data-level="0"]').classList.add('active');
  
  currentLevel = 0;
  navigationHistory = [];
  updateHeader();
}

// Close menu when clicking outside
document.addEventListener('click', (e) => {
  if (!e.target.closest('.mobile-drawer') && !e.target.closest('.mobile-menu-trigger')) {
    const overlay = document.querySelector('.mobile-menu-overlay');
    if (overlay.classList.contains('active')) {
      closeMobileMenu();
    }
  }
});

// Handle escape key
document.addEventListener('keydown', (e) => {
  if (e.key === 'Escape') {
    const overlay = document.querySelector('.mobile-menu-overlay');
    if (overlay.classList.contains('active')) {
      closeMobileMenu();
    }
  }
});

// Handle swipe to close (touch devices)
let touchStartX = 0;
let touchEndX = 0;

document.addEventListener('touchstart', (e) => {
  touchStartX = e.changedTouches[0].screenX;
});

document.addEventListener('touchend', (e) => {
  touchEndX = e.changedTouches[0].screenX;
  const drawer = document.querySelector('.mobile-drawer');
  
  if (drawer.classList.contains('active')) {
    // Swipe left to close
    if (touchStartX - touchEndX > 50) {
      closeMobileMenu();
    }
  }
});
 
